/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InfoGraphicModel } from '../../models/info-graphic-model';

export interface ArticlePublisherIdIdInfoGraphicLanguageIdGet$Plain$Params {
  publisherId: string;
  id: string;
  languageId: string;
}

export function articlePublisherIdIdInfoGraphicLanguageIdGet$Plain(http: HttpClient, rootUrl: string, params: ArticlePublisherIdIdInfoGraphicLanguageIdGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<InfoGraphicModel>> {
  const rb = new RequestBuilder(rootUrl, articlePublisherIdIdInfoGraphicLanguageIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('publisherId', params.publisherId, {});
    rb.path('id', params.id, {});
    rb.path('languageId', params.languageId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<InfoGraphicModel>;
    })
  );
}

articlePublisherIdIdInfoGraphicLanguageIdGet$Plain.PATH = '/Article/{publisherId}/{id}/InfoGraphic/{languageId}';
